import React from 'react';
import { Flex, Box } from 'rebass';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import Link from '../../base/Link/Link';
import Typography from '../Typography/Typography';
import { Type } from '../../base/Type/Type';
import { NewsItemStoryblok } from '../../types/storyblok';

dayjs.extend(relativeTime);

const NewsArticleCard = ({
  category,
  datePublished,
  link,
  publisherName,
  text,
  title,
}: NewsItemStoryblok) => (
  <Box px={[2, 3, 4]}>
    <Flex flexWrap="wrap" mb={['10px', , '25px']}>
      <Typography
        fontWeight="bold"
        mb={0}
        sx={{ textTransform: 'capitalize' }}
        className="font-foundersGrotesk"
      >
        {publisherName ?? category}
      </Typography>
      <Typography
        alignItems="center"
        component="time"
        dateTime={datePublished}
        display="flex"
        variant="body-small"
        className="font-foundersGrotesk"
      >
        {publisherName || category ? '\u00A0— ' : ''}
        {dayjs(datePublished).fromNow()}
      </Typography>
    </Flex>
    <Link href={link}>
      <Type as="h2" className="font-foundersGrotesk text-2xl mb-4">
        {title}
      </Type>
    </Link>
    <Type as="p" className="font-foundersGrotesk">
      {text}
    </Type>
  </Box>
);

export default NewsArticleCard;
